export default __webpack_public_path__ + "static/media/wellness-score.727f0fee.svg";